import { gameTracking } from '../../../Utility/Tracking/FBLegacyTracking';
import { FBTrackingEvent } from '../../../Utility/Tracking/FBTrackingEvent';
import { IGameState } from '../../Game/IGameState';
import { hidePopup } from '../../UI/UIStateHelper';
import { completeMission, isMissionPrizeCoins } from '../PlayerMissionHelper';

export function receiveMissionReward(state: IGameState, mission: number) {
    gameTracking(FBTrackingEvent.Mission_Complete);
    state = { ...state };

    // If prize is "coins", hide current popup (sideMenu).
    if (isMissionPrizeCoins(state.playerState.missions[mission].prize)) {
        state.UIState = hidePopup(state.UIState, state.UIState.popupID, null);
    }

    state = completeMission(state, mission);

    if (
        state.previousState.playerState.keys > state.playerState.keys &&
        state.playerState.keys === 0
    ) {
        gameTracking(FBTrackingEvent.Design_Event_Complete);
    }
    return state;
}
